import axios from "axios"
export const login = (data) => async(dispatch) => {
    try {
        dispatch({type:"LOGIN_PENDING"})
        const response = await axios.post("/api/admin/V1/admin/login",data)
        localStorage.setItem("vn_associates_insurance_admin",JSON.stringify(response.data))
        dispatch({type:"LOGIN_FULFILLED",payload:response.data})
        
    } catch (error) {
        dispatch({type:"LOGIN_FAILED",payload:error.response})
    }
} 

export const logout = () => async(dispatch) =>{
   localStorage.removeItem("vn_associates_insurance_admin")
   dispatch({type:"LOG_OUT_FULFILLED"})
}

export const changePassword = (token, data) => async (dispatch) => {
    try {
        dispatch({ type: "CHANGE_PASSWORD_PENDING" });
        const response = await axios.post(
            "/api/admin/V1/admin/change-password",
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        dispatch({ type: "CHANGE_PASSWORD_FULFILLED", payload: response.data });
    } catch (error) {
        dispatch({ type: "CHANGE_PASSWORD_REJECTED", payload: error.response || error });
    }
};

